module.exports = __webpack_public_path__ + "img/ic_edit_2.b7e646e3.svg";